import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-expenditure-icon',
  templateUrl: './lib-expenditure-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibExpenditureIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
